const projects = [
  {
    id: 1,
    title: 'Kalugera Magazine App',
    description: 'A magazine app built for sharing articles and knowledge.',
    imgSrc: 'https://www.dropbox.com/s/tjjcs3a1o0wc89x/kalu-screen.png?raw=1',
    alt: 'Kalugera Screen',
    source: 'https://github.com/KerronKing/kalugera',
    live: 'https://kalugera.herokuapp.com/',
    styler: 'section-1',
  },
  {
    id: 2,
    title: 'Weather App',
    description: 'A simple weather app built using the Open Weather API and vanilla JS.'
      + ' It displays the weather conditions, local temperature and wind-speed',
    imgSrc: 'https://www.dropbox.com/s/9ddf8ihowzpryor/weather-screen.png?raw=1',
    alt: 'Weather App screen',
    source: 'https://github.com/KerronKing/Weather-App-JS',
    live: 'https://rawcdn.githack.com/KerronKing/Weather-App-JS/cc8049feb723d2478674c1c7444bb7642de725a7/dist/index.html',
    styler: 'section-2',
  },
  {
    id: 3,
    title: 'Facebook Clone',
    description: 'A social app built using Ruby on Rails that allows users to'
      + ' sign in, be-friend other users, make posts, comments and like those posts.',
    imgSrc: 'https://www.dropbox.com/s/jinqqn77708uhix/fb-screen.png?raw=1',
    alt: 'Fb Clone',
    source: 'https://github.com/KerronKing/RoR-Facebook_Clone',
    live: 'https://frozen-hamlet-01864.herokuapp.com',
    styler: 'section-3',
  },
  {
    id: 4,
    title: 'Bookstore CMS',
    description: 'A fast, dynamic and responsive front-end of an application that'
      + ' organizes and manages a bookstore, built with React & Redux.',
    imgSrc: 'https://www.dropbox.com/s/9a1nowg5y9okwtw/bookstore-screen.png?raw=1',
    alt: 'Bookstore screen',
    source: 'https://github.com/KerronKing/react-redux-bookstore',
    live: 'https://kr-bookstore.herokuapp.com/',
    styler: 'section-4',
  },
  {
    id: 5,
    title: 'Budget Tracker',
    description: 'A budget tracking app built with React/Redux that'
      + ' interacts with a REST Api, built with Ruby on Rails',
    imgSrc: 'https://www.dropbox.com/s/0hn2figixikglj3/BT%20Screencap.png?raw=1',
    alt: 'Budget Tracker screen',
    source: 'https://github.com/KerronKing/budget-tracker',
    live: 'https://king-budget-tracker.herokuapp.com/',
    styler: 'section-5',
  },
  {
    id: 6,
    title: 'Battleship',
    description: 'A take on the classic game, Battleship, built with vanilla JS.',
    imgSrc: 'https://www.dropbox.com/s/99x3hkibotx6tok/battleship-screen.png?raw=1',
    alt: 'Battleship Screen',
    source: 'https://github.com/KerronKing/Battleship-JS',
    live: 'https://rawcdn.githack.com/KerronKing/Battleship-JS/56aac3cd696ecbe534c9d4430eeab7607ba826b0/dist/index.html',
    styler: 'section-6',
  },
];

export default projects;
